import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { Capacitor } from '@capacitor/core'
import { App } from '@capacitor/app'
import {SecureStorage} from '@aparajita/capacitor-secure-storage'

import deseguroCompras from './desegurocompras'
import programaSolidaridad from './programa-solidaridad'
import ads from './ads'
import koinonia10 from "@/store/koinonia10"
import utils from "@/store/utils"
import spots from "@/store/spots"

import router from "../router"
import {Network} from "@capacitor/network"

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        id: '',
        status: '',
        activar: localStorage.getItem('msj') || '',
        token: localStorage.getItem('token') || '',
        // USER
        user: null,
        informacion_fiscal: {},
        saldo_publicitario: 0,
        yidi_puntos: 0,
        saldo_bono_especial: 0,
        saldo_alianza: 0,
        get_bono_especial: false,
        saldo_tabla_dispersadora: 0,
        patrocinio_disponible: 0,

        items_in_paquete: [],

        //yatvii
        ytv_busqueda: localStorage.getItem('ytv_busqueda') || '',
        lugar: JSON.parse(localStorage.getItem('lugar')),
        query_ytv: '',
        change_chat: '',
        change_notification: '',
        publicacion_promociones: {},
        compra: {},
        show_menu: true,
        clientes_detalle: [],
        paquetes_detalle: [],
        clientes: [],
        publicacion_item: {},
        compras_pendientes: [],
        asignando_promociones: false,
        promociones_validadas: false,
        title_menu: '',

        //Tienda Virtual
        store: null,
        in_store: false,
        paquetes_order: null,
        agente: null,
        token_agente: localStorage.getItem('token_agente') || '',
        notification: null,
        departamentos: [],
        get_proveedores: false,
        get_inventarios: false,

        departamento_publicaciones: [],

        cuenta_bancaria: {},
        categoria_puntos: {},
        categorias_puntos: [],
        path_back: null,


        // PAQUETES
        mayorista_paquete: {},

        // ASIGNACIONES COMPRA ESPECIAL
        cliente_asignacion: {},
        categorias_especiales: [],

        notificaciones_activas: false,

        compra_publica_gemas: false,
        //conecta
        conecta_saldos_disponibles: [],

        server: '',

        visibleLugaresProduccion: 'activos',

    //  PREVENTAS
        preventa: {},
        lanzamientoActivo: {},
        getPreventaLanzamientos: false,
        item_preventa: 'config',
        item_preventa_lanzamiento: 'products',
        get_sedes: false,
        getDireccionesResponsable: false,
        preventa_productos: {}, //preventa que se visualiza en productos
        codigos_promocionales: {}, //preventa que se visualiza en productos

        bienvenida_libertad: false,

        navColor1: '#FFA500',
        navColor2: '#FF6347',
        navFgColor: {'fg-white': true},

        // FONDOS
        getFondoState: false,

        //Para los usuarios ya loggeados, con esta variable se va a realizar su registro para recibir notificaciones
        notificacionesFirebase: false,

        appVueKey: (Math.random().toString(36)+'00000000000000000').slice(2, 20),
        updateKeyCount: false,

        //Host para crear deep links en la app
        shareHost: "https://app.koinonia10.com/",

        filter_ventas: 'nuevos_pedidos',

        //Host de vsc-web
        vscHost: "https://virtualshoppingclub.com/",

        //Region predeterminada para campañas publicitarias
        regionCampanias: localStorage.getItem('regionCampanias'),

        //Para los filtros de tiempo al recuperar logs de Yidi Puntos, y podría utilizarse para otros logs también
        filterLogs: localStorage.getItem('filter-logs') ? JSON.parse(localStorage.getItem('filter-logs')) :
          {year: true, month: true, day: false},

        //Reemplazo del EventBus
        eventBus: null,

        backgroundImage: null,
        showTopInset: true,

        noPatrocinadorRegistro: localStorage.getItem('no-patrocinador-registro')
    },
    modules: {
        deseguroCompras,
        programaSolidaridad,
        ads,
        koinonia10,
        utils,
        spots
    },
    mutations: {
        SET_GET_BONO_ESPECIAL(state, status){
          state.get_bono_especial = status
        },
        SET_NAVBAR_COLOR(state,{ color1, color2}) {
            state.navColor1 = color1
            state.navColor2 = color2
        },
        SET_NAVBAR_FG_COLOR(state, obj) {
            state.navFgColor = obj
        },

        SET_NOTIFICACIONES_ACTIVAS(state, status) {
            state.notificaciones_activas = status
        },
        SET_CUENTA_BANCARIA(state, cuenta) {
            state.cuenta_bancaria = cuenta
        },
        // Menu
        SET_SHOW_MENU(state, {show_menu, path = null}) {
            state.show_menu = show_menu
            state.path_back = path
        },
        SET_TITLE_MENU(state, title_menu) {
            state.title_menu = title_menu
        },
        auth_request(state) {
            state.status = 'loading'
        },
        auth_success(state, token, id) {
            state.status = 'success'
            state.token = token
            state.num = id
        },
        auth_error(state) {
            state.status = 'error'
        },
        logout(state) {
            state.status = ''
            state.token = ''
        },
        activar(ban) {
            localStorage.setItem('msj', "activar")
        },
        descativar(ban) {
            localStorage.removeItem('msj')
        },
        SET_TOKEN(state, token) {
            state.token = token
        },

        SET_AGENTE(state, agente) {
            state.agente = agente
        },
        SET_TOKEN_AGENTE(state, token) {
            state.token_agente = token
        },

        SHOW_NOTIFICATION(state, notification) {
            state.notification = notification
        },
        SET_USER(state, user) {
            state.user = user
        },
        SET_SERVER(state, server) {
            state.server = server
        },
        SET_SALDO_PUBLICITARIO(state, saldo) {
            state.saldo_publicitario = saldo
        },
        SET_YIDI_PUNTOS(state, yidi_puntos) {
            state.yidi_puntos = yidi_puntos
        },
        SET_SALDO_BONO_ESPECIAL(state, saldo_bono_especial) {
            state.saldo_bono_especial = saldo_bono_especial
        },
        SET_SALDO_ALIANZA(state, saldo_alianza) {
            state.saldo_alianza = saldo_alianza
        },
        SET_SALDO_TABLA_DISPESADORA(state, saldo_tabla_dispersadora) {
            state.saldo_tabla_dispersadora = saldo_tabla_dispersadora
        },
        SET_PATROCINIO_DISPONIBLE(state, patrocinio_disponible) {
            state.patrocinio_disponible = patrocinio_disponible
        },

        SET_INFORMACION_FISCAL(state, informacion_fiscal){
            state.informacion_fiscal = informacion_fiscal
        },

        SET_COMPRA_PUBLICA_GEMAS(state, status) {
            state.compra_publica_gemas = status
        },
        SET_PUNTOS(state, puntos) {
            state.user.puntos = puntos
        },
        SET_INFORMACION(state, informacion) {
            state.user.informacion = informacion
        },
        SET_FUSION_STATUS(state, status) {  //status debe ser true o false
            state.user.fusionado = status
        },

        // TIENDA VIRTUAL
        SET_STORE(state, store) {
            state.store = store
        },
        IS_STORE(state, status) {
            state.in_store = status
        },

        // [] ============COMPRAS=========== []
        SET_COMPRAS_PENDIENTES(state, compras_pendientes) {
            state.compras_pendientes = compras_pendientes
        },
        SET_COMPRA(state, compra) {
            state.compra = compra
        },
        SET_CLIENTES(state, clientes) {
            state.clientes = clientes
        },
        SET_CLIENTES_DETALLE(state, clientes_detalle) {
            state.clientes_detalle = clientes_detalle
        },
        SET_PAQUETES_DETALLE(state, paquetes_detalle) {
            state.paquetes_detalle = paquetes_detalle
        },
        SET_PUBLICACION_ITEM(state, publicacion_item) {
            state.publicacion_item = publicacion_item
        },
        ASIGNANDO_PROMOCIONES(state, status) {
            state.asignando_promociones = status
        },
        PROMOCIONES_VALIDADAS(state, status) {
            state.promociones_validadas = status
        },

        SET_PAQUETES_ORDER(state, paquetes) {
            state.paquetes_order = paquetes
        },


        SET_FILTER_VENTAS(state, filter) {
            state.filter_ventas = filter
        },

        // DESEGUROCOMPRAS
        IN_STORE(state, status) {
            state.in_store = status
        },

        // [] =============================== []
        //yatvii
        SET_QUERY_YTV(state, query) {
            state.query_ytv = query
        },
        SET_BUSQ_YTV(state, tipo) {
            state.ytv_busqueda = tipo
        },
        SET_CHAT(state, valor) {
            state.change_chat = valor
        },
        SET_NOTIFICATION(state, valor) {
            state.change_notification = valor
        },

        SET_DEPARTAMENTOS(state, valor) {
            state.departamentos = valor
        },
        SET_GET_PROVEEDORES(state, valor) {
            state.get_proveedores = valor
        },
        SET_GET_INVENTARIOS(state, valor) {
            state.get_inventarios = valor
        },

        // PUNTOS POR CATEGORIA
        SET_CATEGORIAS_PUNTOS(state, valor) {
            state.categorias_puntos = valor
        },
        SET_CATEGORIA_PUNTOS(state, valor) {
            state.categoria_puntos = valor
        },

        // PAQUETES
        SET_MAYORISTA_PAQUETE(state, valor) {
            state.mayorista_paquete = valor
        },
        // COMPRAS ESPECIALES
        SET_CLIENTE_ASIGNACION(state, valor) {
            state.cliente_asignacion = valor
        },
        SET_CATEGORIAS_ESPECIALES(state, valor) {
            state.categorias_especiales = valor
        },

        //CONECTA
        SET_SALDOS_DISPONIBLES(state, valor) {
            state.conecta_saldos_disponibles = valor
        },

        SET_PREVENTA(state, preventa){
            state.preventa = preventa
        },

        SET_ITEM_MENU_PREVENTA(state, item_preventa){
            state.item_preventa = item_preventa
        },

        SET_ITEM_MENU_PREVENTA_LANZAMIENTO(state, item_preventa_lanzamiento){
            state.item_preventa_lanzamiento = item_preventa_lanzamiento
        },
        SET_PREVENTA_LANZAMIENTO(state, lanzamientoActivo){
            state.lanzamientoActivo = lanzamientoActivo
        },

        SET_GET_PREVENTA_LANZAMIENTOS(state, status){
            state.getPreventaLanzamientos = status
        },

        SET_GET_SEDES(state, status){
            state.get_sedes = status
        },
        SET_GET_DIRECCIONES_RESPONSABLE(state, status){
            state.getDireccionesResponsable = status
        },


        SET_PREVENTA_PRODUCTOS(state, preventa){
            state.preventa_productos = preventa
        },

        SET_CODIGOS_PROMOCIONALES(state, codigos){
            state.codigos_promocionales = codigos
        },

        SET_DEPARTAMENTO_PUBLICACION_ITEMS_PAQUETE(state, items) {
            state.items_in_paquete = items
        },

        SET_VISIBLE_LUGARES_PRODUCCION(state, status) {
            state.visibleLugaresProduccion = status
        },

        SET_GET_FONDO_STATE(state, status) {
            state.getFondoState = status
        },

        SET_NOTIFICACIONES_FIREBASE(state, status) {
            state.notificacionesFirebase = status
        },

        SET_APP_VUE_KEY(state, newKey) {
            state.appVueKey = newKey
        },
        SET_UPDATE_KEY_COUNT(state,status) {
            state.updateKeyCount = status
        },

        SET_SHARE_HOST(state,host) {
            state.shareHost = host
        },

        SET_USER_MUNICIPIO_ID(state,id) {
            if (state.user !== null && typeof state.user.informacion !== 'undefined') {
                state.user.informacion.municipio_id = id
            }
        },

        SET_USER_NEGOCIOS_A_CARGO(state,bool) {
            state.user.negocios_a_cargo = bool
        },

        SET_USER_N0MBRE_COMPLETO(state,nombre) {
            if (state.user !== null && typeof state.user.informacion !== 'undefined') {
                state.user.informacion.nombre_completo = nombre
            }
        },

        SET_VSC_HOST(state,host) {
            state.vscHost = host
        },

        SET_REGION_CAMPANIAS(state,region_id) {
            state.regionCampanias = region_id
            if (region_id !== null) {
                localStorage.setItem('regionCampanias',region_id)
            } else {
                localStorage.removeItem('regionCampanias')
            }
        },

        SET_FILTER_LOGS(state, obj) {
            state.filterLogs = obj
            localStorage.setItem('filter-logs', JSON.stringify(state.filterLogs))
        },

        SET_EVENT_BUS(state, obj) {
            state.eventBus = obj
        },

        SET_BANK_ACCOUNT_EXISTENCE(state,bool) {
            if (state.user && state.user.informacion) {
                state.user.informacion.user_has_bank_account = bool
            }
        },

        SET_BACKGROUND_IMAGE(state, url) {
            state.backgroundImage = url
        },
        SET_SHOW_TOP_INSET(state, bool) {
            state.showTopInset = bool
        },

        SET_NO_PATROCINADOR_REGISTRO(state, num) {
            state.noPatrocinadorRegistro = num
            if (num) {
                localStorage.setItem('no-patrocinador-registro',num)
            } else {
                localStorage.removeItem('no-patrocinador-registro')
            }
        }
    },
    actions: {
        async login({dispatch, commit}, user) {
            await axios.post('api/login', user).then(async response => {
                if (response.data.reset) {
                    await router.push({path: '/password/new'})
                } else {
                    commit('SET_NO_PATROCINADOR_REGISTRO', null)
                    await dispatch('tryAutoLogin')
                }
            }).catch(error => {
                if (error.response.data.error) {
                    Metro.notify.create(error.response.data.error, null, {cls: "alert"})
                }
            })
        },
        async login_agentes({dispatch, commit}, user) {
            const response = await axios.post('/agentes/auth', user)
            localStorage.setItem('token_agente', response.data.token)
            commit('SET_TOKEN_AGENTE', response.data.token)
            localStorage.setItem('agente', response.data.agente_info)
            commit('SET_AGENTE', response.data.agente_info)
            return dispatch('getAgente')
        },

        async tryAutoLogin({ dispatch }) {
            try {
                await Network.getStatus().then(async status => {
                    if (!status.connected) {
                        await router.push({path: '/inactive-connection'})
                    } else {
                        //new-login-corrections
                        //Después quitar lo relacionado a token
                        const token = await SecureStorage.get('access-token')
                        if (token) {
                            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
                        }
                        await dispatch('getUser')
                        if (token) {
                            await SecureStorage.clear()
                            axios.defaults.headers.common['Authorization'] = ""
                        }
                    }
                })
            } catch (error) {
                console.log('logged out')
                await dispatch('logoutActions')
            }
        },

        async logout({dispatch}) {
            //Mandar ads e intermedios interactuados
            dispatch('sendShowedAds')
            dispatch('sendShowedIntermedios', true)
            //Esperar 200ms y luego solicitar el logout a la API
            await new Promise(resolve => {
                setTimeout(async () => {
                    await axios.post(`api/logout`).then(async () => {
                        await dispatch('explicitLogoutActions')
                        await dispatch('logoutActions')
                    })
                    resolve()
                }, 200)
            })
        },

        async logoutActions({dispatch, commit}) {
            //Remover items del localStorage y borrar carros del store
            //new-login-corrections
            await SecureStorage.clear()
            axios.defaults.headers.common['Authorization'] = ""
            await localStorage.removeItem('cart_products')
            await localStorage.removeItem('carroSucursal')
            await localStorage.removeItem('formNegocioData')
            commit('SET_CARRITO',[])
            commit('SET_CARRO_SUCURSAL',{})
            commit('SET_FAVORITOS',[])
            commit("SET_CUENTA_BANCARIA", {})
            commit("SET_USER", null)

            await dispatch('initialApp')
        },

        async explicitLogoutActions({commit}) {
            commit("SET_LOCALIZACION", null)
        },

        async logoutAgente({commit, state}) {
            //Remover items del localStorage y borrar carros del store
            await localStorage.removeItem('token_agente')
            await localStorage.removeItem('agente')
            await localStorage.removeItem('cart_products')
            await localStorage.removeItem('carroSucursal')
            await localStorage.removeItem('formNegocioData')
            commit('SET_CARRITO',[])
            commit('SET_CARRO_SUCURSAL',{})
            commit('SET_FAVORITOS',[])
            commit("SET_AGENTE", null)
        },
        async registrar({dispatch}, user) {
            const response = await axios.post('api/registrar', {user: user})
            return dispatch('getUser')
        },
        async getAgente({commit}) {
            return axios.get('api/v2/agentes/info',
                {headers: {"Authorization": `Bearer ${localStorage.getItem('token_agente')}`}}
            ).then(response => {
                if (response.data) {
                    commit('SET_AGENTE', response.data)
                }
            }).catch(() => {
                commit("SET_AGENTE", null)
            });
        },
        async getUser({dispatch, commit, state}) {
            const localizationMissing = state.deseguroCompras.localizacion === null
            await axios.get('api/account-info', {
                params: {
                    get_localizacion: localizationMissing
                }
            }).then(response => {
                if (response.data) {
                    commit("SET_USER", response.data.user)
                    commit("SET_SALDO_PUBLICITARIO", response.data.user.saldo_publicitario)
                    commit("SET_SALDO_BONO_ESPECIAL", response.data.user.saldo_bono_especial)
                    commit("SET_SALDO_ALIANZA", response.data.user.saldo_alianza)
                    commit("SET_YIDI_PUNTOS", response.data.user.yidipuntos)
                    commit("SET_SALDO_TABLA_DISPESADORA", response.data.user.saldo_tabla_dispersadora)
                    commit("SET_PATROCINIO_DISPONIBLE", response.data.user.patrocinio)
                    commit("SET_SERVER", response.data.server)
                    commit("SET_PUNTOS", response.data.puntos)
                    commit("SET_INFORMACION", response.data.informacion)
                    commit("SET_DEPARTAMENTOS", response.data.departamentos)
                    commit("SET_SHARE_HOST", response.data.share_host)
                    commit("SET_VSC_HOST", response.data.vsc_host)

                    if (localizationMissing && response.data.localizacion !== null) {
                        commit("SET_LOCALIZACION", response.data.localizacion)
                    } else if (!localizationMissing && response.data.informacion.region_interes_id === null) {
                        axios.post('api/v2/users/set-region-interes.json', {
                            region_id: state.deseguroCompras.localizacion.id_muni
                        }).catch(() => {})
                    }
                }
            }).catch(() => {
                commit("SET_USER", null)
            })
            await dispatch('initialApp')
        },
        async initialApp() {
            if (!localStorage.getItem('help_general')) {
                await axios.get('api/initial-app').then(response => {
                    const response_data = response.data
                    if (response_data) {
                        localStorage.setItem('help_general', JSON.stringify(response.data.help_general_slugs))
                    }
                })
            }
        },
        //======= yatvii ===============
        set_tipo_busqueda_ytv({commit}, tipo) {
            localStorage.setItem('ytv_busqueda', tipo)
            commit("SET_BUSQ_YTV", tipo)
        },

        async refreshState({getters, commit, dispatch}) {
            commit('SET_CUENTA_BANCARIA',{})
            if (getters.isLoggedIn) {
                await dispatch('getUser')
            }
        }
    },
    getters: {
        isLoggedIn: state => !!state.user,
        isLoggedAgente: state => !!state.agente,
        authStatus: state => state.status,
        showMenu: state => state.show_menu,
        isActivar: state => !!state.activar,
        ytv_busqueda: state => state.ytv_busqueda,
        lugar: state => !!state.lugar,
        compra: state => state.compra,
        getBonoEspecial: state => state.get_bono_especial,
        optionLugaresProduccion: state => state.visibleLugaresProduccion,
        preventaEditing: state => state.preventa,
        getPreventaLanzamientos: state => state.getPreventaLanzamientos,
        getDireccionesResponsable: state => state.getDireccionesResponsable,
        getSedes: state => state.get_sedes,
        lanzamientoActivo: state => state.lanzamientoActivo,
        menuOptionPreventalanzamiento: state => state.item_preventa_lanzamiento,
        menuOptionPreventa: state => state.item_preventa,
        navFgColor: state => state.navFgColor,
        getFondoState: state => state.getFondoState,
        fusionado: state => state.user.fusionado,
        notificacionesFirebase: state => state.notificacionesFirebase,
        appVueKey: state => state.appVueKey,
        updateKeyCount: state => state.updateKeyCount,
        shareHost: state => state.shareHost,
        filterVentas: state => state.filter_ventas,
        vscHost: state => state.vscHost,
        regionCampanias: state => state.regionCampanias,
        user: state => state.user,
        filterLogs: state => state.filterLogs,
        eventBus: state => state.eventBus,
        cuentaBancaria: state => state.cuenta_bancaria,
        backgroundImage: state => state.backgroundImage,
        navColor1: state => state.navColor1,
        navColor2: state => state.navColor2,
        showTopInset: state => state.showTopInset,
        departamentos: state => state.departamentos,

        bonoEspecial: state => state.saldo_bono_especial,
        yidiPuntos: state => state.yidi_puntos,
        saldoPublicitario: state => state.saldo_publicitario,
        saldoAlianza: state => state.saldo_alianza,
        tablaDispersadora: state => state.saldo_tabla_dispersadora,
        patrocinio: state => state.patrocinio_disponible,

        noPatrocinadorRegistro: state => state.noPatrocinadorRegistro,
    }
})
